import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Form, Input, InputNumber, message } from 'antd';

const CreditModal = ({
  open,
  onCancel,
  onSubmit,
  selectedCarHouse,
  creditForm,
}) => {
  const { t } = useTranslation();
  const handleOk = async () => {
    try {
      await creditForm.validateFields();
      onSubmit(creditForm.getFieldsValue());
      creditForm.resetFields();
    } catch (error) {
      message.error(t('subscriptions.fillFieldsError'));
    }
  };

  return (
    <Modal
      title={t('subscriptions.addCreditsTo', {
        carHouse: selectedCarHouse?.name,
      })}
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      okText={t('subscriptions.addCredit')}
      cancelText={t('common.cancel')}
    >
      <Form form={creditForm} layout="vertical" name="creditForm">
        <Form.Item
          name="amount"
          label={t('subscriptions.credits')}
          rules={[
            { required: true, message: t('subscriptions.enterCreditAmount') },
          ]}
        >
          <InputNumber
            style={{ width: '100%' }}
            placeholder={t('subscriptions.enterCreditAmount')}
          />
        </Form.Item>

        <Form.Item name="description" label={t('subscriptions.description')}>
          <Input placeholder={t('subscriptions.descriptionPlaceholder')} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreditModal;
